import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn(ModalService, $translate, $scope, $stateParams, $q, PolicyService) {
    var ctrl = Object.create(BaseCtrl);
    ctrl.init = function () {
        $scope.policyNumber = $stateParams.policyNumber;
        ctrl.getNotes();
    };

    ctrl.getNotes = function () {
        var notesRequest = PolicyService.getNotesForPolicy($stateParams.policyNumber);
        $scope.notesRequest = notesRequest;

        $q.when(notesRequest, function (notes) {
            $scope.notes = notes;
        }, function () {
            var msg = $translate('gateway.views.policy-detail.notes.error', { policyNumber: $stateParams.policyNumber });
            ModalService.showError('gateway.views.modal.Error', msg);
        });
    };

    return ctrl.create($scope);
};
fn.$inject = ['ModalService', '$translate', '$scope', '$stateParams', '$q', 'PolicyService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/policy/PolicyNotesCtrl.js
// module id = 1710
// module chunks = 0